<template>
  <div id="Status">
    <v-row
      class="text-table py-0 mt-0"
      :class="nodeIndex % 2 !== 0 ? 'off' : ''"
    >
      <div v-for="(sticks, index) in status" :key="sticks.name">
        <span v-if="index === 0">
          <v-chip
            class="ma-2 mr-1"
            :color="getColor(sticks.name)"
            text-color="white"
            x-small
          >
            {{ sticks.name }}
          </v-chip></span
        >
        <span v-else>
          <v-chip
            class="ma-2"
            :color="getColor(sticks.name)"
            text-color="white"
            x-small
          >
            {{ sticks.name }}
          </v-chip>
        </span>
      </div>
    </v-row>
  </div>
</template>
<script>
export default {
  name: "Status",
  props: {
    status: {
      default: () => [],
      type: Array,
    },
    nodeIndex: {
      default: () => 0,
      type: Number,
    },
  },
  methods: {
    getColor(sticksName) {
      switch (sticksName) {
        case "Pendente":
          return "warning";
        case "Entrega Direta":
          return "primary";
        case "Aceito Pelo Transbordo":
          return "primary";
        case "Alocado para Entregador":
          return "primary";
        case "Quarentena de Transferência":
          return "warning";
        case "Entregue Com Sucesso":
          return "green";
        case "Entregue com Pendência":
          return "warning";
        case "Extraviado":
          return "error";
        case "A Devolver":
          return "warning";
        case "Devolvido Com Sucesso":
          return "deep-purple darken-1";
        case "Devolvido Com Pendência":
          return "error";
        case "Devolvido para Reentrega":
          return "error";
        case "Em transferência":
          return "primary";
        case "Quarentena de Entrega":
          return "warning";
        case "Tentar entregar novamente":
          return "warning";
        case "Devolvido Pelo Transbordo":
          return "warning";
        default:
          return "primary";
      }
    },
  },
};
</script>

<style></style>
